const adminGuide =
  "";

const keycloakHomepageURL = "";

export default {
  documentationUrl: adminGuide,
  clientsUrl: `${adminGuide}`,
  clientScopesUrl: `${adminGuide}`,
  realmRolesUrl: `${adminGuide}`,
  usersUrl: `${adminGuide}`,
  groupsUrl: `${adminGuide}`,
  sessionsUrl: `${adminGuide}`,
  eventsUrl: `${adminGuide}`, 
  realmSettingsUrl: `${adminGuide}`,
  authenticationUrl: `${adminGuide}`,
  identityProvidersUrl: `${adminGuide}`,
  userFederationUrl: `${adminGuide}`,
  documentation: `${keycloakHomepageURL}`,
  guides: `${keycloakHomepageURL}`,
  community: `${keycloakHomepageURL}`,
  blog: `${keycloakHomepageURL}`,
  workflowsUrl: `${adminGuide}`,
};
